var _excluded = ["action", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { Button } from '@osui/ui';
import { IconAddSolid } from '@baidu/ee-icon';
import { IconRefreshs, IconDownload, IconCustomNav } from '@baidu/lsqm-icon';
import classNames from 'classnames';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
var ActionButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var action = _ref.action,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var iconNode = useMemo(function () {
    switch (action) {
      case 'create':
        return /*#__PURE__*/_jsx(IconAddSolid, {
          className: 'icloud-ui-action-button-icon icon-create'
        });

      case 'refresh':
        return /*#__PURE__*/_jsx(IconRefreshs, {
          className: 'icloud-ui-action-button-icon'
        });

      case 'download':
        return /*#__PURE__*/_jsx(IconDownload, {
          className: 'icloud-ui-action-button-icon'
        });

      case 'customNav':
        return /*#__PURE__*/_jsx(IconCustomNav, {
          className: 'icloud-ui-action-button-icon'
        });
    }
  }, [action]);
  return /*#__PURE__*/_jsx(Button, _objectSpread({
    flexCenter: true,
    ref: ref,
    icon: iconNode,
    className: classNames(className, 'icloud-ui-action-button-wrap')
  }, props));
});
export default ActionButton;
//# sourceMappingURL=es/index.js.map